import compact from "lodash/compact";
import range from "lodash/range";
import { SelectCommonProps, SelectV2 } from "PFComponents/select_v2";
import { Option } from "PFTypes/options";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

type YearSelectorProps = {
  min: number;
  max: number;
  value: number;
  onChange: (selectedYear: number) => void;
} & Omit<SelectCommonProps<number>, "onChange" | "dropdownWidth">;

export const YearSelector = ({
  min: minYear,
  max: maxYear,
  value,
  onChange,
  ...selectProps
}: YearSelectorProps) => {
  const { t } = useTranslation("core", { keyPrefix: "components.calendar" });

  const yearOptions: Option<number>[] = useMemo(() => {
    const selectedYearOption = {
      id: value,
      value: value.toString(),
      original: value
    };

    return compact([
      value < minYear && selectedYearOption,
      ...range(minYear, maxYear).map((year) => ({
        id: year,
        value: year.toString(),
        original: year
      })),
      value > maxYear && selectedYearOption
    ]);
  }, [value, minYear, maxYear]);

  return (
    <SelectV2<number>
      title={t("selectYear")}
      qaId={"calendar-select-year"}
      value={value}
      options={yearOptions}
      onChange={({ id: value }: Option<number>) => {
        onChange(value as number);
      }}
      dropdownWidth={200}
      noPortal
      {...selectProps}
    />
  );
};
